module.exports = __webpack_public_path__ + "img/location.073cb15d.svg";